import { useEffect, useState } from 'react';

import { activePanelState, completePanelState, Panel, PanelStatus, resetPanelState } from '@foradevelopment/fora-ui';
import { manageWorkersMatomo, matomoTracking } from '@fora-monorepo/webapp-analytics';

import { EmploymentConfirmationDetailsSettingsOld, layoutSizeSettings } from '../../components';
import { AddEmploymentPanel } from '../panels/AddEmployment/AddEmploymentPanel';
import { AddEmploymentConfirmationPanel } from '../panels/AddEmployment/AddEmploymentConfirmationPanel';

export const AddEmploymentView = () => {
  const [panelStates, setPanelStates] = useState({
    form: activePanelState(),
    confirmation: resetPanelState(),
  });
  const [confirmationDetailsSettings, setConfirmationDetailsSettings] = useState<
    EmploymentConfirmationDetailsSettingsOld | undefined
  >();

  const goToAddConfirmationPanel = (confirmationDetailsSettings: EmploymentConfirmationDetailsSettingsOld) => {
    setPanelStates({
      form: completePanelState(),
      confirmation: activePanelState(),
    });
    setConfirmationDetailsSettings(confirmationDetailsSettings);
  };

  const resetPanels = () => {
    setPanelStates({
      form: activePanelState(),
      confirmation: resetPanelState(),
    });
  };

  useEffect(() => {
    if (panelStates.form.status === PanelStatus.Active) {
      matomoTracking(manageWorkersMatomo, 'lägg till');
    }
    if (panelStates.confirmation.status === PanelStatus.Active) {
      matomoTracking(manageWorkersMatomo, 'kvittens');
    }
  }, [panelStates.form.status, panelStates.confirmation.status]);

  return (
    <Panel.List
      paddingLeft={0}
      paddingRight={0}
      marginLeft={layoutSizeSettings.removePadding}
      marginRight={layoutSizeSettings.removePadding}
    >
      <AddEmploymentPanel panelState={panelStates.form} goToNextPanel={goToAddConfirmationPanel} />
      <AddEmploymentConfirmationPanel
        panelState={panelStates.confirmation}
        resetPanels={resetPanels}
        confirmationDetailsSettings={confirmationDetailsSettings}
      />
    </Panel.List>
  );
};
